<div id="barres" [ngClass]="(!enProd) ? 'dev':'prod'">
  <nav class="navbar navbar-expand-md navbar-light navbar-custom" [ngClass]="{'shrink':navBarShrink}">
    <div class="container">
      <a [ngClass]="{'shrink':navBarShrink}" routerLink="/" id="logo" class="pl-0 pr-0 navbar-brand nav-link">
        <img
          class="pr-2" style="float: left;" alt="Ministère de la Justice" src="./assets/img/logoRp.png" height=100 />
        <img
          class="pr-2" style="float: left;" alt="SSM du Ministère de la Justice" src="./assets/img/logoSser.svg" height=100 />
        <span class="titre">Ministère de la Justice<br />Secrétariat Général<br />SSER</span>
      </a>
      <div>
        <a *ngIf="navBarShrink" routerLink="/" class="pl-0 pr-0 navbar-brand nav-link"><span
            class="titre">{{title}}</span><mat-spinner [hidden]="(spinner.hidden$ | async)" diameter=32 style="
                  display: inline;
                  position: absolute;
                  margin-top: 0.2em;
                  margin-left: 0.5em"></mat-spinner></a>
      </div>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#menuprincipal"
        aria-expanded="false" aria-controls="menuprincipal" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="menuprincipal">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item mx-1 px-1 my-1" [ngClass]="{'active': authPage && authPage.isActive}" [hidden]="AUTH.isUtilisateurAuthentifie()">
            <a #authPage="routerLinkActive"
              class="nav-link" routerLinkActive="active" routerLink="/authentification" title="Connexion à l'enquête"><span><i
                  class="material-icons md-18" aria-hidden="true">person</i> Authentification</span></a></li>
          <li class="nav-item mx-1 px-1 my-1" [ngClass]="{'active': saisiePage && saisiePage.isActive}" [hidden]="! ROLES.isHabilite(['enquete'])"><a class="nav-link"
              routerLinkActive="active" #saisiePage="routerLinkActive" routerLink="/saisie" title="Ecran de saisie de l'enquête"><i
                class="material-icons md-18 mr-1" aria-hidden="true">edit</i> Saisie</a></li>

          <li class="nav-item mx-1 px-1 my-1" [hidden]="! ROLES.isHabilite(['enquete'])"><a class="nav-link"      
            href="/assets/Notice_explicative.pdf" target="_blank" title="Notice explicative">
            <i class="material-icons md-18 mr-1" aria-hidden="true">picture_as_pdf</i> Notice</a></li>

          <li class="nav-item mx-1 px-1 my-1"><a class="nav-link" href="#" data-toggle="modal"
                title="Aide sur la présentation et les fonctionnalités de l'outil de saisie"
              data-target="#aideModal"><i class="material-icons md-18 mr-1" aria-hidden="true">help</i> Aide</a></li>
          <!-- possible de gérer active -->
          <li class="nav-item mx-1 px-1 my-1" [ngClass]="{'active': suiviPage && suiviPage.isActive}"
            [hidden]="! ROLES.isHabilite(['gestionnaire'])">
            <a class="nav-link" routerLinkActive="active" routerLink="/suivi-saisie" #suiviPage="routerLinkActive" title="Ecrans de suivi de la saisie"><i
                class="material-icons md-18 mr-1" aria-hidden="true">folder_open</i> Suivi</a></li>
        </ul>
        
        <a *ngIf="AUTH.isUtilisateurAuthentifie()" class="badge badge-danger ml-2" routerLink=""
          (click)="cliqueSeDeconnecter()" alt="Se déconnecter"><span alt="Se déconnecter"><i class="material-icons"
              title="Se déconnecter" aria-hidden="true">power_settings_new</i></span></a>
      </div>
    </div>
  </nav>
  <!-- Barre d’information utile pour résumer en haut de l’écran les informations importantes
        Utile lors d’une saisie en interne-->
        <bis-infobar *ngIf="saisiePage  && saisiePage.isActive && formulaireService.getRootForm()"></bis-infobar>
</div>

<!-- Modal -->
<div class="modal fade" id="aideModal" tabindex="-1" role="dialog" aria-labelledby="aideModalTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="aideModalTitle"><B><I>Aide</I></B></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div *ngIf="authPage && authPage.isActive" class="col aideJustify">
          <h3><b>Se connecter</b></h3>
          <p> L’authentification des applications du SSER est liée à l’annuaire du ministère de la Justice, qui
            recense tous les
            agents et éléments de structure.
            Vous pouvez vous connecter en utilisant :</p>
          <ul>
            <li>votre adresse mail <kbd>prenom.nom&#64;justice.fr</kbd> ;</li>
            <li>
              l’adresse de votre boîte fonctionnelle (par exemple : <kbd>dg.tj-nantes&#64;justice.fr</kbd>)<br>
              Si vous ne connaissez pas le mot de passe associé à la boîte fonctionnelle, vous pouvez le demander à
              votre
              correspondant informatique local.
            </li>
          </ul>
        </div>
        <div *ngIf="(saisiePage && saisiePage.isActive) || (suiviPage && suiviPage.isActive)" class="col aideJustify">
            <h3><B>Généralités</B></h3>
            <div class="col">
              <h5><B>Navigateur</B></h5>
                <p>
                  Comme pour toute application, il faut éviter d'ouvrir l'enquête sur plusieurs onglets différents en même temps,
                  vous risqueriez sinon de perdre des données saisies sur un des onglets.<br>
                  Le navigateur web à privilégier est Microsoft Edge, mais Mozilla Firefox peut être utilisé.
                </p>
            </div>  
            <div class="col">
              <h5><B>Le questionnaire</B></h5>
               <div class="col">
                <p>
                  Le questionnaire comprend 9 onglets dont un onglet commentaire. Chacun regroupe des questions sur un même thème indiqué dans le ‘chapeau’ de chaque onglet.<br>
                  L’onglet sur lequel on se trouve est matérialisé par un trait bleu sous son titre.<br>
                  Au fur et à mesure de la saisie des informations, la couleur des titres des onglets varie et indique<br>
                  - en rouge la présence d’anomalies bloquantes<br>
                  - en orange la présence d’anomalies non bloquantes<br>
                  - en noir l’absence de toute anomalie. 
                </p>
                <p>
                  <U>Pour se déplacer d’un onglet à l’autre</U>, on peut utiliser la souris ou les boutons ‘Précédent’ et ‘Suivant’ situés en bas de chaque onglet.
                </p>
                <p>
                  <U>Pour se déplacer de zone à zone</U>, on peut utiliser la souris ou la touche ‘tabulation’ qui fait déplacer le curseur de gauche à droite.
                </p>
                <p>
                  <U>Pour renseigner les informations</U><br>
                  Selon les zones, il faudra utiliser le pavé numérique ou alphabétique pour les zones à remplir et la souris pour les cases à cocher et les menus déroulants.<br>
                  Certaines zones grisées correspondent à des calculs automatiques. Elles vous sont inaccessibles.
                </p>
                <p>
                  <U>Affichage conditionnel</U><br>
                  Selon l'information renseignée, certaines zones supplémentaires peuvent s'afficher. 
                  C'est le cas notamment de ‘zones textes’ qui vous permettront de préciser une rubrique renseignée à « autres ».
                </p>
                <p>
                  <U>Saisie des nombres avec décimales</U><br>
                  Pour la saisie des valeurs décimales, séparer les unités des décimales par un point.
                </p>
                <p>
                  Des messages et couleurs peuvent apparaître et indiquent des anomalies ou des indications de saisie.<br>
                  L’indicateur jaune signale une incohérence à vérifier.<br>
                  L’indicateur rouge désigne une erreur bloquante, qui doit obligatoirement être corrigée.
                </p>
              </div>
              <h5><B><I>Les contrôles bloquants</I></B></h5>
              <div class="col">
                <p>
                  Si le titre d’un onglet du questionnaire est en rouge, cela signifie qu’il contient au moins une erreur bloquante.<br> 
                  Le champ en erreur apparaît encadré en rouge si cette variable n'a pas été renseignée ou est erronée.<br>
                </p>
              </div>
              <h5><B><I>Les alertes</I></B></h5>
              <div class="col">
                <p>
                  Les alertes apparaissent en jaune. Celles-ci ne sont pas bloquantes et n’empêchent donc pas la validation du questionnaire.
                </p>
              </div>
              <h5><B><I>Les totaux</I></B></h5>
              <div class="col">
                <p>
                  Ce bouton <button class="btn-info mr-2" title="Calcul automatique du total à partir des données ventilées"><b><i>Calcul automatique</i></b></button> permet 
                  de calculer les totaux de la ligne ou colonne en référence. Il est aussi possible de compléter les totaux par une saisie manuelle.
                  Le renseignement des totaux est obligatoire.
                </p>
              </div>
            </div>
            <br>
            <div class="col">
              <h4><B><I>Fonctionnalités des boutons</I></B></h4>
              <div class="col">
                <div *ngIf="ROLES.isHabilite('gestionnaire')" class="col">
                  <h5><B><I>Afficher</I></B></h5>
                  <div class="col">
                    <p>
                      Le bouton <button class="btn btn-style btn-primary"><i class="material-icons md-18 mr-1" aria-hidden="true">cloud_download</i>Afficher</button> permet de charger un questionnaire suivant la structure choisie...
                    </p>
                  </div>
                </div>
                <h5><B><I>Enregistrer partiellement une saisie : <button class="btn btn-enq btn-primary mx-1 col-3"><i class="material-icons md-18 mr-1" aria-hidden="true">save</i> Sauvegarder</button></I></B></h5>
                <div class="col">
                    <p>
                      À tout moment il est possible d’enregistrer votre saisie. La saisie est considérée comme provisoire et non validée.<br> 
                      Cette fonctionnalité est utile s'il vous est impossible de finir la saisie en cours ou parce qu'une erreur bloquante empêche la validation
                      de votre questionnaire.<br>
                    </p>
                </div>
                <div class="col">
                  <h5><B><I>Validation d'un questionnaire : <button class="btn btn-enq btn-success mx-1 col-2"><i class="material-icons md-18 mr-1" aria-hidden="true">send</i> Valider</button></I></B></h5>
                  <div class="col">
                    <p>
                      Ce bouton devient actif uniquement quand le questionnaire est complet et sans erreur bloquante (indicateur rouge).<br>
                      <span class="valider">En cliquant sur ce bouton, votre questionnaire sera considéré comme validé mais vous pourrez le modifier tant que la campagne est ouverte.</span>
                    </p>
                  </div>
                </div>
                <div *ngIf="ROLES.isHabilite('gestionnaire')" class="col">
                  <h5><B><I>Suppression d'un questionnaire</I></B></h5>
                  <div class="col">
                    <p>
                      Ce bouton <button class="btn btn-style btn-danger mx-1"><i class="material-icons md-18 mr-1" aria-hidden="true">delete</i> Supprimer</button> permet de supprimer définitivement le questionnaire en cours.
                    </p>
                  </div>
                </div>
                <div *ngIf="ROLES.isHabilite('gestionnaire')" class="col">
                  <h5><B><I>Quitter</I></B></h5>
                  <div class="col">
                    <p>
                      Le bouton <button class="btn btn-style btn-info"><i class="material-icons md-18 mr-1" aria-hidden="true">exit_to_app</i>Quitter</button> permet de passer d’un questionnaire à un autre pour le gestionnaire. Il est nécessaire de sauvegarder ou valider le questionnaire avant de passer à un autre.
                    </p>
                  </div>
                </div>
              </div>  
              <br>
              <div class="col">
                <h4><B><I>Fonctionnalités / Menu</I></B></h4>
                <div class="col">
                  <h5><B><I>Synthèse BAV</I></B></h5>
                  <div class="col">
                      <p>
                        Cet onglet permet d’accéder à la synthèse (automatique) qui recense la globalité des données saisies de tous les BAV dans l'onglet F.
                      </p>
                  </div>
                </div>
                <div class="col">
                  <h5><B><I>Notice</I></B></h5>
                  <div class="col">
                      <p>
                        Ce bouton permet d’accéder à la notice explicative qui apporte des précisions ou des définitions sur les informations demandées dans le questionnaire.<br>
                        Il est fortement recommandé de la lire avant de débuter la saisie.
                      </p>
                  </div>
                </div>
                <div *ngIf="ROLES.isHabilite('gestionnaire')" class="col">
                  <h5><B><I>Suivi</I></B></h5>
                  <div class="col">
                    <p>
                      Ce bouton permet de visualiser le suivi d’enquête global.
                    </p>
                  </div>
                </div>
                <div class="col">
                  <h5><B><I>Se déconnecter</I></B></h5>
                  <div class="col">
                    <p>
                      Le bouton « <i class="badge badge-danger material-icons">power_settings_new</i> »
                      permet de se déconnecter de l'enquête.<br>
                    </p>
                  </div>
                </div>
                <br>
              </div>        
        </div>
        <br>
        <div class="row">
          <div class="col-lg-7">
            <h3><b>
              But de l’enquête</b>
            </h3>
            <div class="aideJustify" [innerHTML]="butEnquete"></div>
          </div>
          <div class="col-lg-5 ml-auto">
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">Contact</h3>
                <ul class="list-unstyled">
                  <li class="card-text">
                    <i class="material-icons" style="vertical-align: text-bottom;">
                      contact_mail
                    </i>
                    <span *ngIf="ROLES.isHabilite(['gestionnaire'])"> <a [href]="'mailto:'+contactBis.mail"> {{
                      contactBis.mail}}</a></span>
                      <span *ngIf="! ROLES.isHabilite(['gestionnaire'])"> <a [href]="'mailto:'+contactBcps.mail"> {{
                        contactBcps.mail}}</a></span>
                  </li>
                  <li class="card-text">
                    <i class="material-icons" style="vertical-align: text-bottom;">
                      contact_phone
                    </i>
                    <span *ngIf="ROLES.isHabilite(['gestionnaire'])"> {{ contactBis.tel }}</span>
                    <span *ngIf="! ROLES.isHabilite(['gestionnaire'])"> {{ contactBcps.tel }}</span>
                  </li>
                </ul>
                <p class="card-text text-right">
                  <small>
                    Version de l’application – {{version}}
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>


        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Fermer</button>
        </div>
      </div>
    </div>
  </div>

</div>